module.exports = __webpack_public_path__ + "static/media/SWSCRC1-34.c0d2fb04.mp3";